import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Dialogmessage from '../../dialog';
import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";

class Add extends Component {

  state = {
    load: false,
    message: '',
    error: '',
    dialogstatus: false,
    display: 'show'
  }

  addBranch() {
    let context = this;
    let partno = this.props.partno;
    let branch = document.getElementById('branch').value;
    let stock = document.getElementById('stock').value;
    let rack = document.getElementById('rack').value;

    if (branch == '' || branch == null || branch == undefined) {
      context.setState({ error: 'Enter branch fields!!!' })
      return;
    }
    if (stock == '' || stock == null || stock == undefined) {
      context.setState({ error: 'Enter stock fields!!!' })
      return;
    }
    if (rack == '' || rack == null || rack == undefined) {
      context.setState({ error: 'Enter rack no fields!!!' })
      return;
    }
    context.setState({
      load: true,
      message: 'Spare Branch Adding!!!'
    });
    let data1 = {'partno': partno, 'branch': branch, 'min_stock': stock, 'rackno': rack};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addbranch.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          context.setState({
            load: false,
            dialogmessage: 'Branch added successfully!!!',
            dialogstatus: true,
            display: 'none',
            error: ''
          });
        }
        else {
          context.setState({
            load: false,
          });
          alert('Try again');
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  closedialog() {
    this.setState({
      dialogstatus: false
    })
  }

  clear() {
    document.getElementById("branch").value = "";
    document.getElementById("stock").value = "";
    document.getElementById("rack").value = "";
  }

  render() {
    let { load, message, dialogmessage, dialogstatus } = this.state;
    let loading, dialogs;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (dialogstatus) {
      dialogs = (<Dialogmessage message={dialogmessage} closedialog={this.closedialog.bind(this)} dialogstatus={dialogstatus} />)
    }
    return (
      <div style={{padding: '1%'}}>
        <Card fluid>
          <Grid style={{padding: '1%'}}>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              Brach<br/>
              <Input id='branch' focus placeholder='Branch' style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              Min Stock<br/>
              <Input id='stock' focus type="number" placeholder='Min Stock' style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              Rack No<br/>
              <Input id='rack' focus placeholder='Rack No' style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <center><div style={{color: 'red', fontSize: 13, fontWeight: 'bold'}}>{this.state.error}</div></center>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8} style={{display: this.state.display}}>
              <Button color='red' fluid onClick={this.clear.bind(this)}>Clear</Button>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8} style={{display: this.state.display}}>
              <Button fluid positive onClick={this.addBranch.bind(this)}>Save</Button>
            </Grid.Column>
          </Grid>
        </Card>
        {loading}
        {dialogs}
      </div>
    );
  }
}

export default Add;
